import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthContext';
import { Loading } from '../components/Loading';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  const location = useLocation();
  if (session === undefined) return <Loading />;
  if (!session) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/entrar?next=${next}`} replace />;
  }
  return children;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { session } = useAuth();
  if (session === undefined) return <Loading />;
  if (!session) return <Navigate to="/entrar?next=%2Fadmin" replace />;
  if (!session.isStaff) return <Navigate to="/campanas" replace />;
  return children;
}

/** Envía a cada quien a su inicio: admins al panel, clientes a sus campañas. */
export function HomeRedirect() {
  const { session } = useAuth();
  if (session === undefined) return <Loading />;
  if (!session) return <Navigate to="/entrar" replace />;
  return <Navigate to={session.isStaff ? '/admin' : '/campanas'} replace />;
}
